import script from "./LoginTop.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginTop.vue?vue&type=script&setup=true&lang=ts"

import "./LoginTop.vue?vue&type=style&index=0&id=2b396802&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b396802"]])

export default __exports__